import { render, staticRenderFns } from "./AgentForm.vue?vue&type=template&id=845fd9ac&scoped=true&"
import script from "./AgentForm.vue?vue&type=script&lang=js&"
export * from "./AgentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845fd9ac",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSelect,VTextField,VTextarea,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('845fd9ac')) {
      api.createRecord('845fd9ac', component.options)
    } else {
      api.reload('845fd9ac', component.options)
    }
    module.hot.accept("./AgentForm.vue?vue&type=template&id=845fd9ac&scoped=true&", function () {
      api.rerender('845fd9ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Agent/components/Agent/AgentForm.vue"
export default component.exports